var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 239,
    viewBox: "0 0 236 239",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 118,
    cy: 119.229,
    rx: 118,
    ry: 119.229,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M130.633 84.729L90.664 69.738C87.2393 68.4665 83.4454 68.6511 80.1847 70.2917L70.7717 74.9879C68.4954 76.1363 68.3313 79.315 70.4641 80.689L100.59 100.069L80.3898 110.384L68.4544 105.072C66.6702 104.273 64.599 104.314 62.8558 105.196L56.2524 108.497C54.3452 109.461 53.8325 111.943 55.227 113.563L70.218 131.056C71.469 132.512 73.2942 133.352 75.2014 133.352H103.44C104.466 133.352 105.47 133.106 106.373 132.655L162.338 104.683C171.874 99.9046 179.257 91.7016 183.01 81.7144C184.958 76.5465 181.123 71.0095 175.586 71.0095H163.814C159.672 71.0095 155.57 71.9938 151.879 73.8805L130.633 84.729ZM52.4995 159.602C52.4995 163.232 55.4321 166.164 59.0619 166.164H177.185C180.815 166.164 183.748 163.232 183.748 159.602C183.748 155.972 180.815 153.04 177.185 153.04H59.0619C55.4321 153.04 52.4995 155.972 52.4995 159.602Z",
    fill: "#FA0073"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDep);
export default __webpack_public_path__ + "static/media/dep.617821c33c07f724029166afe3b02920.svg";
export { ForwardRef as ReactComponent };